import { MdOutlineDashboardCustomize } from "react-icons/md";
import {
  AiFillCaretDown,
  AiOutlineSearch,
  AiOutlineTags,
} from "react-icons/ai";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { IoChatboxOutline } from "react-icons/io5";

import { useLocation } from "react-router-dom";
export const crmMenu = [
  {
    name: "داشبورد",
    path: "/dashboard/crm",
    icon: <MdOutlineDashboardCustomize size={20} />,
    type: "menu",
    child: ["/dashboard/crm", "/dashboard/crm/customer-file"],
  },

  {
    name: "گزارشگیری",
    path: "/dashboard/crm/reporting",
    icon: <HiOutlineDocumentReport size={20} />,
    type: "menu",
    child: [
      "/dashboard/crm/reporting",
      "/dashboard/crm/reporting/Invoicelesscustomers",
      "/dashboard/crm/reporting/marker",
      "/dashboard/crm/reporting/Transactionsbasedonpersons",
      "/dashboard/crm/reporting/tradinglist",
      "/dashboard/crm/reporting/todayactivities",
      "/dashboard/crm/reporting/userswithoutactivity",
      "/dashboard/crm/reporting/activitiesdonetoday",
      "/dashboard/crm/reporting/firstfiles",
      "/dashboard/crm/reporting/allActivityAndChances",
      "/dashboard/crm/Chart",
      "/dashboard/crm/reporting/passedActivities",
      "/dashboard/crm/reporting/CluesWithoutActivity",
      "/dashboard/crm/reporting/CustomersWithoutActivity",
      "/dashboard/crm/reporting/DeletedFiles",
      "/dashboard/crm/reporting/UsersList",
    ],
  },
  {
    name: "جستجوی پیشرفته",
    path: "/dashboard/crm/advancedsearch",
    icon: <AiOutlineSearch size={20} />,
    type: "menu",
    child: ["/dashboard/crm/advancedsearch"],
  },
  {
    name: "چت آنلاین",
    path: "/dashboard/crm/OnlineChat",
    icon: <IoChatboxOutline size={20} />,
    type: "menu",
    child: ["/dashboard/crm/OnlineChat"],
  },
  {
    name: "برچسب",
    path: "/dashboard/crm/tags",
    icon: <AiOutlineTags size={20} />,
    type: "menu",
    child: ["/dashboard/crm/tags"],
  },
  {
    name: "دسته بندی CRM",
    path: "/dashboard/crm/grouping",
    icon: <AiFillCaretDown size={20} />,
    type: "menu",
    child: ["/dashboard/crm/grouping"],
  },
  {
    name: "URL",
    path: "/dashboard/crm/urlInserter",
    icon: <AiOutlineTags size={20} />,
    type: "menu",
    child: ["/dashboard/crm/urlInserter"],
  },
];
